<template>
  <v-layout fill-height>
    <v-sheet color="white" width="100%" height="100%" elevation="0">
      <v-row align="center" justify="center" fill-height>
        <v-col cols="6" v-if="!$vuetify.breakpoint.xs">
          <v-img height="105vh" :src="loginImg"></v-img>
        </v-col>
        <v-col style="margin-top: -2%">
          <v-card
            max-width="544"
            elevation="0"
            class="pa-5 mx-auto"
            align="center"
          >
            <v-img
              :src="logo"
              max-width="150"
              contain
              position="center center"
            />

            <v-card-title align="center" class="px-0 justify-center">
              <label class="bold-text4"
                >Dein Konto registrieren</label
              ></v-card-title
            >
            <label class="bold-text2">{{ currentTitle }}</label>
            <v-card-title
              style="width: 30%"
              class="my-3 title font-weight-regular justify-space-between"
            >
              <v-avatar
                :color="step === 1 ? 'secondary' : 'grey'"
                class="subheading white--text"
                size="24"
                >1
              </v-avatar>
              <v-divider></v-divider>
              <v-avatar
                :color="step === 2 ? 'secondary' : 'grey'"
                class="subheading white--text"
                size="24"
                >2
              </v-avatar>
            </v-card-title>
            <v-window v-model="step">
              <v-window-item :value="1">
                <v-form ref="form1" v-model="valid" lazy-validation>
                  <v-container class="py-0">
                    <v-row
                      dense
                      width="100%"
                      class="d-flex align-space-between flex-wrap"
                    >
                      <v-col
                        cols="12"
                        sm="3"
                        class="py-0 mr-5 d-flex flex-column"
                      >
                        <v-label>Anrede</v-label>
                        <v-select
                          dense
                          outlined
                          :items="salutation"
                          v-model="users.salutation"
                          item-text="text"
                          item-value="value"
                          :rules="[fieldRules.emptySelection]"
                          required
                        ></v-select>
                      </v-col>
                      <v-col class="py-0 mr-5 d-flex flex-column">
                        <v-label>Vorname</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="users.firstname"
                          :rules="[fieldRules.empty]"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0 d-flex flex-column">
                        <v-label>Nachname</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="users.lastname"
                          :rules="[fieldRules.emptySelection]"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="12"
                        sm="6"
                        class="py-0 mr-5 d-flex flex-column"
                      >
                        <v-label>E-Mail</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="users.email"
                          :rules="[
                            fieldRules.empty,
                            fieldRules.length50,
                            fieldRules.email,
                          ]"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0 d-flex flex-column">
                        <v-label>E-Mail bestätigen</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="users.confirmedEmail"
                          :rules="[
                            fieldRules.confirmation(
                              users.email,
                              users.confirmedEmail,
                              'E-Mail Adressen stimmen nicht überein'
                            ),
                          ]"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="12"
                        sm="6"
                        class="py-0 mr-5 d-flex flex-column"
                      >
                        <v-label>Passwort</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="users.password"
                          type="password"
                          :rules="[fieldRules.empty, fieldRules.length6]"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0 d-flex flex-column">
                        <v-label>Passwort bestätigen</v-label>
                        <v-text-field
                          dense
                          outlined
                          type="password"
                          v-model="users.confirmedPassword"
                          :rules="[
                            fieldRules.confirmation(
                              users.password,
                              users.confirmedPassword,
                              'Passwörter stimmen nicht überein'
                            ),
                          ]"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-window-item>
              <v-window-item :value="2">
                <v-form ref="form2" v-model="valid" lazy-validation>
                  <v-container class="py-0">
                    <v-row dense class="d-flex justify-space-between">
                      <v-col
                        cols="12"
                        sm="6"
                        class="py-0 mr-4 d-flex flex-column"
                      >
                        <v-label>Unternehmen</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="customer.name"
                          :rules="[fieldRules.empty]"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0 d-flex flex-column">
                        <v-label>Nutzertyp</v-label>
                        <v-select
                          dense
                          outlined
                          :items="typeItems"
                          v-model="customer.type"
                          item-text="text"
                          item-value="value"
                          :rules="[fieldRules.emptySelection]"
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col
                        cols="12"
                        sm="8"
                        class="py-0 mr-4 d-flex flex-column"
                      >
                        <v-label>Straße</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="customer.street"
                          :rules="[fieldRules.empty]"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0 d-flex flex-column">
                        <v-label>Hausnummer</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="customer.number"
                          :rules="[fieldRules.empty]"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="3" sm="3" class="py-0 d-flex flex-column">
                        <v-label v-if="!$vuetify.breakpoint.xs"
                          >Postleitzahl</v-label
                        >
                        <v-label v-if="$vuetify.breakpoint.xs">Plz</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="customer.zip"
                          :rules="[fieldRules.empty]"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0 ml-3 d-flex flex-column">
                        <v-label>Ort</v-label>
                        <v-text-field
                          dense
                          outlined
                          v-model="customer.city"
                          :rules="[fieldRules.empty]"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense class="pb-4 d-flex align-center">
                      <v-col cols="1">
                        <v-checkbox
                          required
                          hide-details
                          dense
                          :rules="[fieldRules.emptyCheckbox]"
                        ></v-checkbox>
                      </v-col>
                      <v-col>
                        <p class="text-justify">
                          Ich bestätige, dass ich Geschäftskunde bin, stimme den
                          <a
                            href="https://manushare.de/allgemeine-geschafts-und-nutzungsbedingungen/"
                            target="_blank"
                          >
                            Nutzungsbedingungen
                          </a>
                          und der
                          <a
                            href="https://manushare.de/datenschutzerklaerung/"
                            target="_blank"
                          >
                            Datenschutzerklärung
                          </a>
                          zu und stimme derbKontaktaufnahme im Zusammenhang mit
                          meiner Anmeldung zu.
                        </p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-window-item>
              <v-window-item :value="3">
                <div class="pa-4 text-center">
                  <h2 class="title font-weight-light mb-2">Willkommen auf</h2>
                  <v-img class="mb-4" contain height="128" :src="logo"></v-img>
                  <span class="caption"
                    >Vielen Dank für Ihre Anmeldung! Bitte bestätigen Sie im
                    Anschluss noch Ihre Email-Adresse.</span
                  >
                </div>
              </v-window-item>
            </v-window>
            <v-card-actions class="d-flex justify-end" v-if="step === 1 || step === 2">
              <v-btn
                elevation="0"
                small
                :disabled="step === 1 || step === 3"
                rounded
                @click="stepWizardBackward"
              >
                <v-icon small>mdi-arrow-left</v-icon>
                Zurück
              </v-btn>
              <v-btn
                elevation="0"
                rounded
                small
                :disabled="step >= 3 || !valid"
                color="secondary"
                depressed
                @click="stepWizardForward"
                :loading="loadingBtn"
              >
                Weiter
                <v-icon small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
            <FlyInMessage
              ref="errorMessage"
              type="error"
              :message="errorMessage"
            />
          </v-card>
          <v-card
            max-width="544"
            elevation="0"
            align="center"
            class="mx-auto justify-center"
          >
            <v-card-title align="center" class="justify-center"
              ><label class="bold-text3"
                >Du hast bereits einen Account?</label
              ></v-card-title
            >
            <v-card-subtitle
              style="
                font-family: 'Mulish';
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                letter-spacing: 0.2px;
                color: #303941;
              "
              >Logge dich
              <a href="/login"><label class="color-text">HIER</label></a> auf
              Manushare ein.
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </v-layout>
</template>
<script>
import { SALUTAIONS } from '../components/utils/SalutationTypes'
import { ROLES } from '../components/utils/RoleTypes'
import typeItems from '../components/utils/OrganizationTypes'
import logo from '../../assets/logo-title.png'
import { mapActions } from 'vuex'
import fieldRules from '../components/utils/FieldRules'
import FlyInMessage from '../components/FlyInMessage.vue'
import loginImg from '../../assets/login.jpg'

export default {
	name: 'Register',
	components: { FlyInMessage },
	data: () => ({
		loginImg,
		loadingBtn: false,
		errorMessage: '',
		customer: {
			name: '',
			street: '',
			number: '',
			zip: '',
			city: '',
			type: ''
		},
		users: {
			firstname: '',
			lastname: '',
			email: '',
			confirmedEmail: '',
			password: '',
			confirmedPassword: '',
			salutation: ''
		},
		logo,
		salutation: SALUTAIONS,
		roleTypes: ROLES,
		typeItems: typeItems,
		step: 1,
		valid: false,
		fieldRules: fieldRules
	}),
	computed: {
		currentTitle () {
			switch (this.step) {
			case 1:
				return 'Gib deine Nutzerinformationen ein'
			case 2:
				return 'Gib deine Unternehmensinformationen ein'
			case 3:
				return 'Account angelegt'
			default:
				return 'Fehler'
			}
		}
	},
	methods: {
		...mapActions('auth', ['register']),
		handleSubmitRegistration () {
			const { users, customer } = this
			if (users && customer) {
				users.email = users.email.toLowerCase()
				this.register({ users, customer }).catch((err) => {
					this.step = 4
					const errors = err.response.data.errors
					const errorKeys = Object.keys(errors)
					if (
						typeof errorKeys !== 'undefined' &&
            errorKeys !== null &&
            errorKeys.length !== null &&
            errorKeys.length > 0 &&
            typeof errors[errorKeys[0]] !== 'undefined' &&
            errors[errorKeys[0]] !== null &&
            errors[errorKeys[0]].length !== null &&
            errors[errorKeys[0]].length > 0
					) {
						this.errorMessage = errors[errorKeys[0]][0]
						this.$refs.errorMessage.show()
						return
					}
					this.errorMessage = err
				})
				this.step++
			}
		},
		stepWizardForward () {
			if (this.step === 2) {
				if (!this.$refs.form2.validate()) {
					this.loadingBtn = false
					return
				}
				this.handleSubmitRegistration()
			} else {
				if (!this.$refs.form1.validate()) return
				this.step++
			}
		},
		stepWizardBackward () {
			this.$refs.form1.resetValidation()
			this.$refs.form2.resetValidation()
			this.step--
		}
	}
}
</script>
<!--
Todos:
 - Valid == next button disabled
-->

<style scoped>
.bold-text3 {
  /* Du hast bereits einen Account? */

  /* Header 2 */
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;

  text-align: center;
  letter-spacing: -0.02em;

  /* Primär Farbe */
  color: #303941;
}

.bold-text4 {
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;

  /* identical to box height */
  text-align: center;
  letter-spacing: -0.02em;

  /* Primär Farbe */
  color: #303941;
}

.bold-text2 {
  /* Label */
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  text-align: center;

  /* Info Text */
  color: #667085;
}

.color-text {
  color: #19d3da !important;
}
</style>
<style scoped>
.v-label {
  text-align: left;
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #303941;
}
.v-text-field--outlined >>> fieldset {
  box-sizing: border-box;
  position: absolute;
  background: #fcfdfe;
  border: 1px solid #f0f1f7;
  color: #303941;
}

.v-text-field {
  border-radius: 8px;
  font-family: "Karla";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

.theme--light .v-btn {
  font-family: "Karla";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
}

.v-avatar {
  /* Field Input */

  font-family: "Karla";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;
}

.text-checkbox {
  font-family: "Karla";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: -0.02em;

  color: #667085;
}

.text-justify {
  font-family: "Karla";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: -0.02em;
  margin-bottom: 2px;
  margin-left: 5px;

  color: #667085;
}
</style>
